import * as React from 'react'
import * as ReactDOM from 'react-dom'

// 全局样式文件
import './index.scss'

// 热更新
import {AppContainer} from 'react-hot-loader'
import {IntlProvider} from 'react-intl';
import langObj from '@src/locale/lang'

// 路由注册
import AppRouter from './router'

// store服务注册
import {Provider} from 'mobx-react'
import {configure} from 'mobx'
import * as store from './store'
import {getLang} from '@src/utils'

configure({enforceActions: true})

const render = Component => {
    ReactDOM.render(
        <Provider {...store}>
            <AppContainer>
                <IntlProvider locale={getLang()} messages={langObj[getLang()]}>
                    <Component/>
                </IntlProvider>
            </AppContainer>
        </Provider>,
        document.getElementById('app') as HTMLElement
    )
}

render(AppRouter)

if (module.hot) {
    module.hot.accept(['router'], () => {
        import('./router').then(mod => render(mod.default))
    })
}
